import { Injectable } from '@angular/core';
import { sanitizeFileName, SupabaseService } from '@examdojo/core/supabase';
import { from, map, Observable } from 'rxjs';
import * as uuid from 'uuid';
import { UploadedImage } from './image-storage-http.model';

@Injectable()
export class ImageStorageHttpService {
  constructor(private readonly supabase: SupabaseService) {}

  uploadImage(storageName: string, fileName: string, blob: Blob): Observable<UploadedImage> {
    const sanitizedFileName = sanitizeFileName(fileName);

    return from(this.supabase.client.storage.from(storageName).upload(`${uuid.v4()}/${sanitizedFileName}`, blob)).pipe(
      map((response) => {
        if (response.error || !response.data?.path) {
          throw new Error('Failed to upload image');
        }

        return {
          url: response.data?.path,
        };
      }),
    );
  }
}
